import React from 'react'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faYoutube,
  faInstagram,
  faLinkedinIn
} from "@fortawesome/free-brands-svg-icons";
import Navbar from './Navbar';
export default function Contact() {
  return (
    <>
      <Navbar />
      <div className='contact'>
        <div>

          <div class="container-fluid">
            <div class="row">
              <div class="text-center">
                <h3 style={{ marginLeft: "5px" }} class="animate-charcter2">I would Love to hear from you . <br /> Connect with me on the given Social Handles or mail me. </h3>
                <br />
                <br />
                <a href="https://www.youtube.com/channel/UCgSWFRJLA9L05zU1s6_zS0g"
                className="youtube social" rel="noopener noreferrer" target="_blank">
                <FontAwesomeIcon icon={faYoutube} size="2x" />
              </a>

              <a href="https://www.linkedin.com/in/imraan-hussain-02/" className="Linkedin social" rel="noopener noreferrer" target="_blank">
                <FontAwesomeIcon icon={faLinkedinIn} size="2x" />
              </a>
              <a href="https://www.instagram.com/itz_me_imraan/"
                className="instagram social" rel="noopener noreferrer" target="_blank">
                <FontAwesomeIcon icon={faInstagram} size="2x" />
              </a>
              <a href="mailto:imran2hosain@gmail.com"

                className="instagram social" rel="noopener noreferrer" target="_blank">
                <img src={require('./gmail.jpg')} height="47px" width="50px" alt="" />
              </a>
              </div>
            </div>
          </div>
          <div className="grid">
           
              
            
          </div>
          


        </div>

      </div>


    </>
  )
}
